export default __webpack_public_path__ + "static/media/FathersDayBackground.037149a7.png";